import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Survey, SurveyPoint } from './models/Pedology';
import { CreateSurvey } from "./api/models-utils";
import { MapsTabState, mapTabDefault } from "./components/private/tab-state";

export default class PedologyVuexModule extends AbacoVuexModule {
    @State() curPoint!: number[] | null;
    @State() surveys!: Survey[] | null;
    @State({ default: [] }) curSurveys!: Survey[];
    @State({ default: 0 }) triggerLayer!: number;
    @State({ default: false }) pedoMapInLoading!: boolean | null;
    @State({ default: [] }) usdaList!: [];
    @State() surveySelected: Survey | null = null;
    @State() isCreatingSurvey!: boolean;
    @State() numCoordinates!: number[] | null;
    @State() selectedSurveyPoint: SurveyPoint | null = null;
    @State() surveysPoint!: SurveyPoint[] | null;

    @State({ default: false }) showPopup!: boolean;
    @State() resultCreateSurvey: CreateSurvey | null = null;
    @State() mapPoints: { [index: number]: Survey } = {};
    @State() surveyCreated: Survey | null = null;

    @State({ default: mapTabDefault }) mapState!: MapsTabState;

    @State({ default: false }) reloadedPage!: boolean;
    @State({ default: false }) loadingLayer!: boolean;

    @State() canViewPedology!: boolean;
    @State() canEditPedology!: boolean;
    @State({ default: null }) coordsToZoom!: string | null;
}
